/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Agriculture_Environment_Forestry30Inputs */

const en_cv_extract_form_enum_agriculture_environment_forestry30 = /** @type {(inputs: Cv_Extract_Form_Enum_Agriculture_Environment_Forestry30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agriculture, Environment and Forestry`)
};

const de_cv_extract_form_enum_agriculture_environment_forestry30 = /** @type {(inputs: Cv_Extract_Form_Enum_Agriculture_Environment_Forestry30Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Landwirtschaft, Umwelt und Forstwirtschaft`)
};

/**
* | output |
* | --- |
* | "Agriculture, Environment and Forestry" |
*
* @param {Cv_Extract_Form_Enum_Agriculture_Environment_Forestry30Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_agriculture_environment_forestry30 = /** @type {((inputs?: Cv_Extract_Form_Enum_Agriculture_Environment_Forestry30Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Agriculture_Environment_Forestry30Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_agriculture_environment_forestry30(inputs)
	return en_cv_extract_form_enum_agriculture_environment_forestry30(inputs)
});
export { cv_extract_form_enum_agriculture_environment_forestry30 as "cv_extract_form_enum_AGRICULTURE_ENVIRONMENT_FORESTRY" }